export enum AlertDialogs {
    'EffectivePrompts' = 'EffectivePrompts'
}